/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// Add global, Buffer, and process for libraries expecting Node.js
(window as any).global = window;
// index.html may leave an array placeholder; libraries need the real Buffer API.
if (!(window as any).Buffer || typeof (window as any).Buffer.isBuffer !== 'function') {
    (window as any).Buffer = require('buffer').Buffer;
}
(window as any).process = (window as any).process || {
    env: { DEBUG: undefined },
    version: [],
    cwd: () => '/'
};

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js/dist/zone'; // Included with Angular CLI.
